// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kPfWlmLCFh0YE6MqPFIB .Xax56xRwvURRD5JkncsO{flex-wrap:wrap;gap:8px;display:flex}.kPfWlmLCFh0YE6MqPFIB .Xax56xRwvURRD5JkncsO .SETf7nZLmTQ3xNwPH4qw{border:1px solid var(--border-neutral-default);width:100%}@media (min-width:768px){.kPfWlmLCFh0YE6MqPFIB .Xax56xRwvURRD5JkncsO .SETf7nZLmTQ3xNwPH4qw{width:calc(50% - 4px)}}.kPfWlmLCFh0YE6MqPFIB .Xax56xRwvURRD5JkncsO .SETf7nZLmTQ3xNwPH4qw.KHcDbLL0sdIVhMxMczrJ{border:1px solid var(--border-brand-default);background:var(--light-blue-10)}.kPfWlmLCFh0YE6MqPFIB .Om007FFuxE0dC_3RHUka{height:44px;margin-top:40px;font-size:14px;font-weight:500}.kPfWlmLCFh0YE6MqPFIB .eDn1__wr8Sv8X_LrkuF8{margin-top:20px;margin-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kPfWlmLCFh0YE6MqPFIB`,
	"wrapSizes": `Xax56xRwvURRD5JkncsO`,
	"inputSize": `SETf7nZLmTQ3xNwPH4qw`,
	"active": `KHcDbLL0sdIVhMxMczrJ`,
	"button": `Om007FFuxE0dC_3RHUka`,
	"inputLabel": `eDn1__wr8Sv8X_LrkuF8`
};
export default ___CSS_LOADER_EXPORT___;
